import { render, staticRenderFns } from "./other-product.vue?vue&type=template&id=0fda9cac&scoped=true&"
import script from "./other-product.vue?vue&type=script&lang=js&"
export * from "./other-product.vue?vue&type=script&lang=js&"
import style0 from "./other-product.vue?vue&type=style&index=0&id=0fda9cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda9cac",
  null
  
)

export default component.exports